import { IconComponentsProps } from './types';

const DocumentIcon = ({ fill = 'currentColor', ...props }: IconComponentsProps) => (
  <svg width="60" height="84" viewBox="0 0 60 84" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M59.1 21.9001L38.1 0.900088C37.836 0.606931 37.5115 0.374619 37.1489 0.219224C36.7864 0.0638283 36.3943 -0.0109411 36 8.81476e-05H6C4.41014 0.00475761 2.88673 0.638398 1.76252 1.76261C0.63831 2.88681 0.00466946 4.41023 0 6.00009V78.0001C0.00466946 79.59 0.63831 81.1134 1.76252 82.2376C2.88673 83.3618 4.41014 83.9954 6 84.0001H54C55.5899 83.9954 57.1133 83.3618 58.2375 82.2376C59.3617 81.1134 59.9953 79.59 60 78.0001V24.0001C60.011 23.6058 59.9363 23.2137 59.7809 22.8511C59.6255 22.4886 59.3932 22.1641 59.1 21.9001ZM36 7.20009L52.8 24.0001H36V7.20009ZM54 78.0001H6V6.00009H30V24.0001C30.0047 25.59 30.6383 27.1134 31.7625 28.2376C32.8867 29.3618 34.4101 29.9954 36 30.0001H54V78.0001Z"
      fill={fill}
    />
  </svg>
);

export default DocumentIcon;
